import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import CardWidget, { Colors } from '../../../components/CardWidget'
import CardWidgetSkeleton from '../../../components/skeletons/CardWidgetSkeleton'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { GET_REVENUE } from '../../../queries/factory'
import { formatCurrency } from '../../../utils/Helpers'

const TotalRevenue = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_REVENUE, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Receita" number={formatCurrency(data.aggregation.aggregations.total.value, 2)} color={Colors.green} />
  )
}

export default TotalRevenue
